import React, { Fragment } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { DEPOSIT } from "utils/contants";
import { formatPrice } from "utils/helpers";

const InformationCommon = ({ preOrder, depositTransfer, discountMoney, isPaidAll = false }) => {
  // console.log('InformationCommon preOrder: ', preOrder)
  const { pathname } = useLocation();

  const isPaidPage = pathname.includes("/order-status/paid");
  const isCompletePage = pathname.includes("/order-status/complete");
  const isPaymentPage = pathname.includes("/payment-page");
  const isPaymentAll = pathname.includes("/payment-all");
  const isPaidCompleted =
    preOrder?.PAYMENTTYPE === 1 && preOrder?.TOTALMONEY >= preOrder?.PRICE;

  const jsx_render = () => {
    if (isPaidAll) {
      return (
        <li>
          <label>Tổng tiền: </label>
          <span className="price price-blue">{formatPrice(preOrder?.productSelect?.price, true)}</span>
        </li>
      );
    }
    if (preOrder?.PAYMENTSTATUSTYPE == 1) {
      return (
        <Fragment>
          <li>
            <label>Số tiền thanh toán: </label>
            <span className="price">
              {formatPrice(preOrder?.TOTALMONEY, true)}
            </span>
          </li>
        </Fragment>
      );
    } else if (preOrder?.PAYMENTSTATUSTYPE == 2) {
      return (
        <Fragment>
          <li>
            {!isCompletePage && (isPaymentAll || isPaidPage) ? (
              <label>Số tiền đã cọc: </label>
            ) : (
              <label>Tổng tiền: </label>
            )}
            <span className="price price-black">
              {formatPrice(preOrder.TOTALMONEY, true)}
            </span>
          </li>
          {discountMoney && (
            <li>
              <label>Mã khuyến mại: </label>
              <span className="price b-price">
                -{formatPrice(discountMoney, true)}
              </span>
            </li>
          )}
          {(isPaidPage || isPaymentAll) && !isPaidCompleted && (
            <li>
              <label>Số tiền còn lại cần thanh toán: </label>
              <span className="price b-price price-blue">
                {formatPrice(
                  depositTransfer ?? preOrder?.PRICE - preOrder?.TOTALMONEY,
                  true
                )}
              </span>
            </li>
          )}
        </Fragment>
      );
    }
    if (preOrder?.PAYMENTSTATUSTYPE == 0) {
      return (
        <li>
          <strong>Tổng tiền: </strong>
          <span className="price price-blue">{formatPrice(DEPOSIT, true)}</span>
        </li>
      );
    }
  };

  const paymentFormNames = (preOrder?.PAYMENTFORMNAMES || "").split("|");
  const preOrderPaymentForm =
    paymentFormNames?.length > 0 ? paymentFormNames[0] : null;
  const paidOrderPaymentForm =
    paymentFormNames?.length > 0 ? paymentFormNames[1] : null;
  const _paymentForm = paidOrderPaymentForm || preOrderPaymentForm;

  return (
    <div className="sd_info_common">
  

      <ul>
        {/* <div className="sd_info_common_barcode">
          <img
            alt="bar code"
            src={preOrder?.BARCODE}
            style={{ maxWidth: "100%", margin: "5px 0", height: "50px" }}
          />
          <label>(Vui lòng bảo mật thông tin)</label>
        </div> */}
        {/* {!isPaidAll && <li>
          <div>
            <label>Mã đơn hàng: </label>
            <span>{preOrder?.PREORDERNO}</span>
          </div>
        </li>} */}
        {/* {isPaidAll && <li>
          <div>
            <label>Mã đơn hàng: </label>
            <span>{preOrder?.ORDERNO}</span>
          </div>
        </li>} */}
        <li>
          <strong>Người đặt hàng: </strong>
          <span>{preOrder?.CUSTOMERNAME}</span>
        </li>
        <li>
          <strong>Số điện thoại: </strong>
          <span>{preOrder?.PHONENUMBER}</span>
        </li>
        {/* <li>
          <strong>Email: </strong>
          <span>{preOrder?.EMAIL}</span>
        </li> */}
        <li>
          <strong>Nhận sản phẩm tại: </strong>
          <span>{preOrder?.ADDRESSDETAIL}</span>
        </li>
        {_paymentForm && !isPaymentAll && (
          <li>
            <strong>Hình thức thanh toán: </strong>
            <span>{_paymentForm}</span>
          </li>
        )}
        {jsx_render()}
      </ul>
    </div>
  );
};

export default InformationCommon;
